import React, { useContext, useState } from 'react';

import Logo from 'assets/img/midrive-transfer-icon.svg';

import Modal from 'components/modal';
import Payment from 'components/payment';

import pause from 'helpers/pause';

import fetchPaymentSecret from 'actions/fetch-payment-secret';
import verifyPayment from 'actions/verify-payment';

import NotificationContext from 'contexts/notification-context';

import LocaleContext from 'contexts/locale-context';

import './index.css';

const PAYMENT_VERIFICATION_TIME = 20;

let cb = null;
let cbReject = null;

const withPayment = () => Component => (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [transferId, setTransferId] = useState(null);
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState(null);

    const { translations } = useContext(LocaleContext);
    const jsTranslations = translations.js;

    const { setNotification } = useContext(NotificationContext);

    const openPayment = ({ selected, transferId, password } = {}) => new Promise((resolve, reject) => {
        setTransferId(transferId)
        setPassword(password)
        setSelected(selected)

        if (transferId) setIsOpen(true);
        cb = resolve;
        cbReject = reject;
    })

    const closeConfirm = (error) => {
        setIsOpen(false)

        if (error) {
            if (cbReject) cbReject()
        } else {
            if (cb) cb();
        }
    };

    const onSubmit = ({ setLoading, selected = {}, onPayment, onError, transferId, password }) => async (ev, { elements, stripe, email }) => {
        ev.preventDefault();

        const processingError = new Error();
        processingError.process = true;
      
        setLoading(true);

        try {
          const selectedFeatures = Object.values(selected).map(selection => {
            selection.payload.email = email;
            return selection;
          });
      
          /**
           * Add the email to all the features
           */
          const featuresAndPayload = selectedFeatures.map(feature => {
            return {
              name: feature.name,
              fields: feature.payload
            }
          })

          let pwd = null;
          if (password) {
            pwd = password.pass ? password.pass : password;
          }

          const response = await fetchPaymentSecret(transferId, pwd, {
            features: featuresAndPayload,
            processor: "STRIPE",
            email
          })
      
          if (response) {
            const paymentIntentClientStripesecret = response.secret
      
            const result = await stripe.confirmCardPayment(paymentIntentClientStripesecret, {
              payment_method: {
                card: elements.getElement('card')
              }
            });
        
            if (result && result.paymentIntent  && result.paymentIntent.status === 'succeeded') {
              let time = 0;
      
              while(true) {
                await pause(1000);
      
                try {
                  await verifyPayment(transferId, {
                    payment_secret: paymentIntentClientStripesecret,
                    features: selectedFeatures.map(feat => ({ name: feat.name }))
                  })
          
                  if (onPayment) onPayment(email);
                  closeConfirm()
      
                  break;
                } catch(e) {
                  if (time < PAYMENT_VERIFICATION_TIME) time++;
                  else {
                    if (onError) onError(e);
                    break;
                  }
                }
              }
            } else {
              if (onError) onError(processingError)
            }
          } else {
            if (onError) onError(processingError)
          }
        } catch(e) {
          // console.log(e)
          setLoading(false);
      
          if (onError) onError(processingError)
        }
      
        setLoading(false);
    }

    const onPayment = email => {
        setNotification({
            title: jsTranslations.success,
            message: jsTranslations.email_success.replace('{EMAIL}', email),
            type: 'success'
        })

        if (cb) cb();
        setIsOpen(false);
    }
      
    const onError = () => {
        setNotification({
            title: jsTranslations.payment_failed,
            message: `${jsTranslations.sorry_payment}.`,
            type: 'danger'
        })
    }

    const extrasCount = Object.keys(selected).length;

    return (
        <>
            <Component
                {...props}
                openPayment={openPayment}
                closeConfirm={closeConfirm}
            />
            <div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={closeConfirm}
                    className='withpayment'
                >
                    <div className='withpayment__modal'>
                        <img src={Logo} alt='MiDrive logo' className='withpayment__modal__logo'/>

                        <h3 className='withpayment__modal__text withpayment__modal__title'>
                            MiDrive Transfer
                        </h3>

                        <p className='withpayment__modal__text'>{extrasCount} x {extrasCount === 1 ? jsTranslations.extra : jsTranslations.extras}</p>

                        <Payment
                            onSubmit={
                                onSubmit({ setLoading, selected, onPayment, onError, transferId, password })
                            }
                            loading={loading}
                        />
                    </div>
                </Modal>
            </div>
        </>
    )
};

export default withPayment;